<template>
    <div class="hero-slide">
        <a class="hero-stage" v-if="item.externalLink" target="_blank" :href="item.externalLink">
            <video ref="video" v-if="item.videoUrl" :poster="item.imageUrl" :autoplay="videoOptions.autoplay"
                :muted="videoOptions.muted" playsinline :preload="videoOptions.preload" :loop="videoOptions.loop">
                <source :src="item.videoUrl" type="video/mp4">
            </video>
            <img class="lazy lazyload" v-else-if="item.imageUrl" :data-src="item.imageUrl" :src="thumbnail"
                :alt="item.caption || item.title" />
        </a>
        <a v-else-if="item.uri" class="hero-stage" :href="item.uri">
            <video ref="video" v-if="item.videoUrl" :poster="item.imageUrl" :autoplay="videoOptions.autoplay"
                :muted="videoOptions.muted" playsinline :preload="videoOptions.preload" :loop="videoOptions.loop">
                <source :src="item.videoUrl" type="video/mp4">
            </video>
            <img class="lazy lazyload" v-else-if="item.imageUrl" :data-src="item.imageUrl" :src="thumbnail"
                :alt="item.caption || item.title" />
        </a>
        <div class="hero-stage" v-else>
            <video ref="video" v-if="item.videoUrl" :poster="item.imageUrl" :autoplay="videoOptions.autoplay"
                :muted="videoOptions.muted" playsinline :preload="videoOptions.preload" :loop="videoOptions.loop">
                <source :src="item.videoUrl" type="video/mp4">
            </video>
            <img class="lazy lazyload" v-else-if="item.imageUrl" :data-src="item.imageUrl" :src="thumbnail"
                :alt="item.caption || item.title" />
        </div>

        <div class="video-control" v-if="item.videoUrl && canplayVideo">
            <button class="video-control-play" type="button" @click="pause" v-if="isVideoPlaying">
                <span class="material-symbols-outlined">pause_circle</span>
            </button>
            <button class="video-control-play" type="button" @click="play" v-if="!isVideoPlaying">
                <span class="material-symbols-outlined">play_circle</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['item', 'thumbnail'],

    data() {
        return {
            videoOptions: {
                autoplay: this.item.video_autoplay,
                muted: true,
                loop: this.item.video_loop,
                controls: false,
                playsinline: true,
                preload: 'auto',
                poster: this.item.imageUrl,
            },

            canplayVideo: false,
            isVideoPlaying: false,
        }
    },

    created() {
        // console.log('HeroMedia created', this.item);

        if (this.item.video_autoplay) {
            this.isVideoPlaying = true;
        }
    },

    computed: {
        // isVideoPlaying() {
        //     return item  !this.$refs.video.paused;
        // },
    },

    mounted() {
        //  :autoplay="videoOptions.autoplay" :muted="videoOptions.muted" :poster="videoOptions.poster" :loop="videoOptions.loop"

        try {
            const media = this.$refs.video;

            media.addEventListener('canplay', () => {
                this.canplayVideo = true;
            });

            // check if video is playing
            media.addEventListener('play', () => {
                this.isVideoPlaying = true;
            });

            media.addEventListener('pause', () => {
                this.isVideoPlaying = false;
            });

            media.addEventListener('ended', () => {
                // console.log('ended');
                // if (!this.item.video_loop) {
                //     this.isVideoPlaying = false;
                // }
            });
        } catch (error) {
            // console.error('error', error);
        }
    },

    methods: {
        play() {
            this.$refs.video.play();
            this.isVideoPlaying = true;
        },

        pause() {
            this.$refs.video.pause();
            this.isVideoPlaying = false;
        },
    },
}
</script>

<style lang="scss" scoped>
.hero-stage {
    position: absolute;
    inset: 0;

    img,
    video {
        position: absolute;
        inset: 0;

        object-fit: cover;
        width: 100%;
        height: 100%;
    }
}

.video-control {
    position: absolute;
    bottom: 15px;
    left: 15px;
    z-index: 10;
}

.video-control-play {
    background-color: transparent;
    border: none;
    padding: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 40px;
    height: 40px;
    border-radius: 50%;

    color: #fff;

    >span {
        font-size: 38px;
    }
}
</style>